import { defineStore } from 'pinia';
export const useCdcSelectStore = defineStore('cdc-select', {
    state() {
        return {
            loveCarDeliverInfo: {},
        };
    },
    getters: {
        getLoveCarDeliverInfo() {
            return this.loveCarDeliverInfo;
        },
    },
    actions: {
        setLoveCarDeliverInfo(deliverInfo) {
            this.loveCarDeliverInfo = deliverInfo ?? {};
        },
    },
});
